import styles from "../../styles/About.module.scss";

const SendButton = ({ title, onClick, type }) => {
  return (
    <button onClick={onClick} className={styles.sendbtn} type={type}>
      {title}
    </button>
  );
};

export default SendButton;
